(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TaskListTemplateClone',
	};

	var form_id = 'tasklisttemplateclone-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// typeahead to select a vendor
		Adzuki.Typeahead(
			$('#' + form_id + 'vendor'),
			function source(term, display, $self) {
				var url = '/Vendors/searchVendorByType/' + $('#' + form_id + 'travel_type').val() + '/' + term;

				$self.addClass('ajax-spinner');
				Adzuki.Ajax.get(url).then(function _reservationSearch(response) {
					$self.removeClass('ajax-spinner');
					display(response);
				});
			},
			function onSelect(vendor, $self, typeahead) {
				$self.prop('disabled', true);
				$('#' + form_id + 'task_vendor_id').val(vendor.id);
				$('.reset-typeahead').removeClass('hidden');
			}
		);

		$('#reset-vendor').on('click', function _resetVendor(e) {
			e.preventDefault();
			$('.reset-typeahead').addClass('hidden');
			$('#' + form_id + 'vendor').val('');
			$('#' + form_id + 'task_vendor_id').val('');
			$('#' + form_id + 'vendor').prop('disabled', false);
		});

		// hide vendor field if travel type is all
		$('#' + form_id + 'travel_type').change(function _hideVendor() {
			if ($(this).val() === 'all') {
				$('.vendor-field').addClass('hidden');
				$('#' + form_id + 'vendor').val('');
				$('#' + form_id + 'task_vendor_id').val('');
				$('.reset-typeahead').addClass('hidden');
				$('#' + form_id + 'vendor').prop('disabled', false);
			} else {
				$('.vendor-field').removeClass('hidden');
				$('#' + form_id + 'vendor').val('');
				$('#' + form_id + 'task_vendor_id').val('');
				$('.reset-typeahead').addClass('hidden');
				$('#' + form_id + 'vendor').prop('disabled', false);
			}
		});

		Adzuki.TaskManager.initTaskListTemplateForm(form_id);
	};
}(jQuery, window.Adzuki || {}));
